import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Loader from './components/ui/loader'

Vue.config.productionTip = false

Vue.use(require('vue-moment'));

import MaskedInput from 'vue-text-mask'
Vue.component('masked-input', MaskedInput);

import './ml'

let isMobile = window.innerWidth < 600;

// import { MdButton, MdDatepicker, MdDialog, MdContent } from 'vue-material/dist/components'
import MdDatepicker from './static/vue-material/MdDatepicker'
import MdButton from './static/vue-material/MdButton'
import MdDialog from './static/vue-material/MdDialog'
import MdContent from './static/vue-material/MdContent'
import MdRadio from './static/vue-material/MdRadio'

import './static/vue-material/vue-material.css'
import './static/vue-material/default.css'

Vue.use(MdDatepicker);
Vue.use(MdButton);
Vue.use(MdDialog);
Vue.use(MdContent);
Vue.use(MdRadio);
Vue.use(Loader);

export default new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
